import styled from '@emotion/styled'
import { Link } from 'gatsby'
import React, { ReactNode } from 'react'
import BreakPoints from '../../styles/breakPoints'

const Wrapper = styled.div`
  width: 45%;
  display: flex;
  p {
    max-width: 390px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    line-height: 1em;
    &:first-child {
      width: 149px;
      min-width: 149px;
    }
    &:nth-child(2) {
      width: 124px;
      min-width: 124px;
    }
    .arrow {
      padding: 0 5px;
    }
    a {
      color: #00b5a6;
    }
  }
  ${BreakPoints.xxLarge} {
    width: 100vw;
    padding: 2px 10px 0;
    height: 40px;
    align-items: center;
    border-top: solid 1px #e5e5e5;
    p {
      max-width: calc(100vw - 174px);
    }
  }
`

export type IColumnPath = {
  /** タイトル */
  title: string
  /** リンク */
  link?: string
}
type IProps = {
  paths: IColumnPath[]
}

/**
 * コラム用パンくずコンポーネント
 * @constructor
 */
const ColumnPath = ({ paths }: IProps) => (
  <Wrapper>
    {paths.map(({ title, link }, index) => {
      let node: ReactNode
      if (link) node = <Link to={link}>{title}</Link>
      else node = <span>{title}</span>
      return (
        <p key={`topic-path-${index}`}>
          {node}
          {index < paths.length - 1 && <span className="arrow">&gt;</span>}
        </p>
      )
    })}
  </Wrapper>
)

export default ColumnPath
